<div class="central-atualizacoes-container">

  <div class="sidebar">
    <div class="brand-header">
      <div class="brand-icon">
        <img class="img-2"
             src="/assets/img/icons/icon-central-att-logistica-azul.svg"
             alt="Ícone Central de Atualizações"
             style="width: 100%; height: auto;">
      </div>
      <div class="brand-text">
        <h1>Central de Atualizações</h1>
        <p>Atualizações & comunicados</p>
      </div>
    </div>

    <div class="seletor-produto-container">
      <label class="seletor-label">PRODUTO</label>
      <mat-form-field appearance="outline" class="w-100 full-width-field">
        <mat-select [(value)]="produtoSelecionado" (selectionChange)="aoMudarProduto()">
          <mat-option *ngFor="let prod of produtos" [value]="prod.id">
            <span class="produto-dot"></span> {{ prod.descricao }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="categorias-container">
      <label class="seletor-label"></label>
      <ul class="categorias-lista">

        <li (click)="selecionarCategoria(itemInicio)"
            [class.active]="categoriaSelecionada?.id === 'INICIO'">
          <div class="categoria-item-left">
            <mat-icon class="icon-categoria-prefix">{{ itemInicio.icone }}</mat-icon>
            <span class="categoria-nome">{{ itemInicio.nome }}</span>
          </div>
        </li>

        <li *ngFor="let cat of categoriasAtuais"
            (click)="selecionarCategoria(cat)"
            [class.active]="categoriaSelecionada?.id === cat.id">
          <div class="categoria-item-left">
            <span class="categoria-dot-cor" [style.backgroundColor]="cat.cor"></span>
            <span class="categoria-nome">{{ cat.nome }}</span>
          </div>
        </li>

        <li (click)="selecionarCategoria(indique)"
            [class.active]="categoriaSelecionada?.id === 'INDIQUE'">
          <div class="categoria-item-left">
            <span class="categoria-dot-cor" [style.backgroundColor]="indique.cor"></span>
            <span class="categoria-nome">{{ indique.nome }}</span>
          </div>
        </li>

        <li (click)="selecionarCategoria(compartilheopiniao)"
            [class.active]="categoriaSelecionada?.id === 'COMPARTILHE_OPINIAO'">
          <div class="categoria-item-left">
            <span class="categoria-dot-cor" [style.backgroundColor]="compartilheopiniao.cor"></span>
            <span class="categoria-nome">{{ compartilheopiniao.nome }}</span>
          </div>
        </li>

        <li *ngIf="!isProducao">
          <div class="categoria-item-left" (click)="excluirCache()">
            <span class="categoria-dot-cor" [style.backgroundColor]="'#ff0000'"></span>
            <span class="categoria-nome"> Excluir Cache </span>
          </div>
        </li>

      </ul>
    </div>
  </div>

  <div class="conteudo-principal">

    <div class="topo-pesquisa">
      <div class="input-pesquisa-wrapper"
           *ngIf="categoriaSelecionada && !['INICIO', 'INDIQUE'].includes(categoriaSelecionada.id)">
        <mat-icon class="search-icon">search</mat-icon>
        <input type="text"
               [(ngModel)]="termoPesquisa"
               (input)="filtrarPaginas()"
               placeholder="Pesquisar no feed..."/>
      </div>
      <div class="spacer" *ngIf="categoriaSelecionada && ['INICIO', 'INDIQUE']"></div>
      <button mat-icon-button class="btn-fechar-modal" (click)="fecharModal()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="scroll-area-wrapper">

      <div class="tela-inicio" *ngIf="categoriaSelecionada?.id === 'INICIO'">
        <div class="inicio-content">
          <div class="badge-oficial">
            <span class="dot-oficial"></span> SEU CANAL OFICIAL DE ATUALIZAÇÕES
          </div>

          <h1 class="titulo-inicio">
            Tudo o que mudou nos seus <br>
            produtos,<br>
            <span class="texto-cinza">em um só lugar.</span>
          </h1>

          <p class="subtitulo-inicio">
            Comunicados, novidades, melhorias e correções dos produtos <strong>maxMotorista</strong>,
            <strong>maxRoteirizador</strong> e <strong>maxTMS</strong> — segmentados pelo seu perfil de uso.
          </p>
          <div class="mt-5">
            <iframe
              style="width: 110%; max-width: 600px; height: 337px; border-radius: 8px; border: none;"
              src="https://www.youtube.com/embed/FRLgZrDmcUw?autoplay=0&playlist=FRLgZrDmcUw&controls=0&modestbranding=1&rel=0"
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen>
            </iframe>
          </div>

          <div class="titulo-com-linha my-4">
            <span>NOSSAS SOLUÇÕES</span>
          </div>

          <div>
            <img src="/assets/img/marketing/logistica.png" style="max-width: 110%;" alt="Logistica integrações">
          </div>

        </div>
      </div>

      <div class="feed-scroll-area"
           *ngIf="categoriaSelecionada && !['INICIO', 'INDIQUE'].includes(categoriaSelecionada.id) ">

        <div *ngIf="carregando" class="feed-estado-container">
          <mat-spinner diameter="40"></mat-spinner>
          <p>Buscando atualizações...</p>
        </div>

        <div *ngIf="!carregando && paginasFiltradas.length === 0" class="feed-estado-container msg-vazia">
          <mat-icon>layers_clear</mat-icon>
          <p>Nada por aqui ainda</p>
        </div>

        <div *ngIf="!carregando && paginasFiltradas.length > 0" class="feed-timeline">
          <div class="periodo-divisor">
            <span>{{ categoriaSelecionada?.descricao | uppercase }}</span>
            <div class="linha-horizontal"></div>
          </div>

          <ng-container *ngFor="let pagina of paginasFiltradas; let i = index">
          <a
             #cardElement
             [attr.data-index]="i"
             [href]="pagina.linkAcesso"
             target="_blank"
             class="card-atualizacao">

            <div class="card-tag-categoria" [ngStyle]="obterEstiloTag(pagina)">
              <span class="tag-dot" [style.backgroundColor]="obterEstiloTag(pagina)['color']"></span>
              {{ (categoriaSelecionada ? categoriaSelecionada.nome : '') | uppercase }}
            </div>

            <h2 class="card-titulo">
              <div *ngIf="pagina.isLoadingDesc" class="skeleton-container">
                <div class="skeleton-line" style="height: 20px;"></div>
              </div>

              <span *ngIf="!pagina.isLoadingDesc" class="fade-in">
               {{ pagina.titulo }}
              </span>
            </h2>

            <div class="card-descricao-wrapper">
              <div *ngIf="pagina.isLoadingDesc" class="skeleton-container">
                <div class="skeleton-line"></div>
                <div class="skeleton-line short"></div>
              </div>

              <div *ngIf="!pagina.isLoadingDesc"
                   class="card-descricao fade-in"
                   [innerHTML]="pagina.descricao || 'Buscando mais informações...'">
              </div>
            </div>

            <div class="card-footer">
              <span class="card-data" *ngIf="!pagina.isLoadingDesc">
                {{ pagina.dataCriacao | date:'dd/MM/yyyy HH:mm' }}
              </span>
            </div>
          </a>
          </ng-container>
        </div>
      </div>

      <div class="promo-container" *ngIf="categoriaSelecionada?.id === 'INDIQUE'">
        <div class="header-logos">
          <img src="/assets/img/marketing/indique2.webp" alt="Máxima Tech e Indica Aqui">
        </div>

        <h1 class="main-title">
          Por aqui, <span class="highlight">sua recomendação rende 15%</span> do valor de cada negócio fechado. E você
          pode fazer quantas indicações quiser, sem limites!
        </h1>

        <p class="description">
          Pare de guardar boas oportunidades: com o Indica Aqui, você impulsiona o negócio do seu amigo, a cadeia de
          abastecimento e ainda é recompensado por isso.
        </p>

        <div class="cta-container">
          <a href="https://www.conteudo.maximatech.com.br/indicacao" target="_blank" class="cta-button">
            clique aqui e indique
          </a>
        </div>

        <div class="footer-banner mt-5">
          <img src="/assets/img/marketing/indique1.webp" alt="É simples: Indicou, Fechou, Faturou">
        </div>
      </div>

    </div>
  </div>
</div>
